import React, { Component } from 'react';
import SaveForm from './SaveForm';
import NavBar from '../NavBar/NavBar';
import './Save.css';


class Save extends Component {
  render () {
    return (
      <div className="SavePage">
        <NavBar />
        <SaveForm />
      </div>
    )
  }
}

export default Save;



// WEBPACK FOOTER //
// ./src/components/Save/Save.js